module.exports = __webpack_public_path__ + "img/log1.5d58e3c9.png";